module.exports = __webpack_public_path__ + "static/media/crear.389e248f.jpg";